// extracted by mini-css-extract-plugin
export default {"itemWrapper":"style_itemWrapper__nMoT1"};